// Generated by ReScript, PLEASE EDIT WITH CARE

import * as VehicleStatus from "../../../../app/partner/entity/VehicleStatus.bs.js";
import * as OptionTypeUtils$Catalyst from "../../../../../../../../node_modules/@porterin/catalyst/src/utils/OptionTypeUtils.bs.js";

function getDriverVehicleStatus(partnerStatus, partnerLoginStatus) {
  if (partnerLoginStatus) {
    return VehicleStatus.toString(/* Offline */2);
  }
  switch (partnerStatus) {
    case /* Free */0 :
        return VehicleStatus.toString(/* Online */1);
    case /* Allocated */1 :
        return VehicleStatus.toString(/* OnOrder */0);
    case /* Not_Available */2 :
        return VehicleStatus.toString(/* Offline */2);
    
  }
}

function getVM(driverInfo) {
  return {
          hd: {
            label: "Geo Region",
            value: {
              TAG: /* Text */0,
              _0: driverInfo.geoRegion
            }
          },
          tl: {
            hd: {
              label: "Secondary Contact",
              value: {
                TAG: /* Text */0,
                _0: driverInfo.secondaryMobile
              }
            },
            tl: {
              hd: {
                label: "Vehicle Status",
                value: {
                  TAG: /* Text */0,
                  _0: getDriverVehicleStatus(driverInfo.partnerStatus, driverInfo.loginStatus)
                }
              },
              tl: {
                hd: {
                  label: "DIN/MSISDN",
                  value: {
                    TAG: /* Text */0,
                    _0: driverInfo.msisdn
                  }
                },
                tl: {
                  hd: {
                    label: "Partner Category",
                    value: {
                      TAG: /* Text */0,
                      _0: driverInfo.partnerCategory
                    }
                  },
                  tl: {
                    hd: {
                      label: "Sprinklr Cancel Group",
                      value: {
                        TAG: /* Text */0,
                        _0: OptionTypeUtils$Catalyst.getStringFrmOptionalType(driverInfo.sprinklr_guidance)
                      }
                    },
                    tl: /* [] */0
                  }
                }
              }
            }
          }
        };
}

export {
  getDriverVehicleStatus ,
  getVM ,
  
}
/* OptionTypeUtils-Catalyst Not a pure module */
